var React = require('react');

function AddCircleDark (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#323643","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M22 12c0 5.515-4.468 10-10.012 10C6.468 22 2 17.515 2 12S6.467 2 11.988 2C17.532 2 22 6.485 22 12zM6.641 11.79H17.36M12 6.43v10.719"})));
}

AddCircleDark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = AddCircleDark;

AddCircleDark.default = AddCircleDark;
